import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { EmailService } from '@core/services/email.service';
import { MessageService } from '@core/services/message.service';
import { emailValidator } from '@core/custom-validators/email-validator';

@Component({
  selector: 'app-email-modal',
  templateUrl: './email-modal.component.html',
  styleUrls: ['./email-modal.component.scss'],
})
export class EmailModalComponent implements OnInit {
  @Input() emailDigitado: string = '';

  emailForm!: FormGroup;
  salvando = false;

  constructor(
    private fb: FormBuilder,
    private modalRef: NzModalRef,
    private emailService: EmailService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.emailForm = this.fb.group({
      email: [
        this.emailDigitado ?? '',
        [Validators.required, Validators.email, emailValidator],
      ],
    });
  }

  handleOk(): void {
    if (this.emailForm.invalid) {
      this.emailForm.markAllAsTouched();
      return;
    }

    this.salvando = true;
    this.emailService.salvar(this.emailForm.getRawValue()).subscribe({
      next: (dto) => {
        this.salvando = false;
        this.messageService.success('E-mail cadastrado com sucesso!');
        this.modalRef.close(dto);
      },
      error: () => {
        this.salvando = false;
      },
    });
  }

  handleCancel(): void {
    this.modalRef.close();
  }
}
